/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Bid_Package__TitleInputs */

const en_help_center__refund_policy__bid_package__title = /** @type {(inputs: Help_Center__Refund_Policy__Bid_Package__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid Package Refunds`)
};

/**
* | output |
* | --- |
* | "Bid Package Refunds" |
*
* @param {Help_Center__Refund_Policy__Bid_Package__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__bid_package__title = /** @type {((inputs?: Help_Center__Refund_Policy__Bid_Package__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Bid_Package__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__refund_policy__bid_package__title(inputs)
});